import { useTranslation } from 'react-i18next'

import { toast } from '@/hooks/useToast'
import { formatDate } from '@/utils/format-date'

import useBulkScheduleArchiveUsers from '../mutations/useBulkScheduleArchiveUsers'

const useScheduleArchiveUsers = ({
  onSuccess,
  userName
}: {
  onSuccess: () => void
  userName?: string
}) => {
  const { t } = useTranslation('users')

  return useBulkScheduleArchiveUsers({
    onSuccess: ({
      successfully_scheduled,
      unsuccessfully_scheduled,
      cancelled_schedule,
      archiveDate
    }) => {
      if (successfully_scheduled > 0) {
        toast({
          variant: 'success',
          title: userName
            ? t('toast.user-scheduled-archive', {
                NAME: userName
              })
            : t('toast.users-scheduled-archive', {
                count: successfully_scheduled
              }),
          description: t('toast.users-will-be-archived', {
            count: successfully_scheduled,
            DATE: formatDate(archiveDate)
          })
        })
      }

      if (unsuccessfully_scheduled > 0) {
        toast({
          variant: 'error',
          title: userName
            ? t('toast.user-schedule-archive-failed', {
                NAME: userName
              })
            : t('toast.users-schedule-archive-failed', {
                count: unsuccessfully_scheduled
              })
        })
      }

      if (cancelled_schedule && userName) {
        toast({
          variant: 'success',
          title: t('toast.users-undo-schedule-archive', { NAME: userName })
        })
      }
      onSuccess()
    },
    onError: ({ ids, archiveDate }) => {
      if (archiveDate) {
        toast({
          variant: 'error',
          title: userName
            ? t('toast.user-schedule-archive-failed', {
                NAME: userName
              })
            : t('toast.users-schedule-archive-failed', {
                count: ids.length
              })
        })
      } else {
        toast({
          variant: 'error',
          title: t('toast.users-undo-archived-failed', {
            NAME: userName
          })
        })
      }
    }
  })
}

export default useScheduleArchiveUsers
